const getMesByNumber = mes => {
  switch (mes) {
    case 1:
      return 'Jan';
    case 2:
      return 'Fev';
    case 3:
      return 'Mar';
    case 4:
      return 'Abr';
    case 5:
      return 'Mai';
    case 6:
      return 'Jun';
    case 7:
      return 'Jul';
    case 8:
      return 'Ago';
    case 9:
      return 'Set';
    case 10:
      return 'Out';
    case 11:
      return 'Nov';
    default:
      return 'Dez';
  }
};

export const groupPeriodoByProp = (data, propName) =>
  Object.values(
    data.reduce((agg, currentValue) => {
      if (agg[currentValue[propName]] === undefined) {
        const timeFrame =
          propName === 'ano'
            ? currentValue.ano
            : `${currentValue.ano} ${getMesByNumber(currentValue.mes)}`;

        agg[currentValue[propName]] = {
          timeFrame,
          ano: currentValue.ano,
          mes: currentValue.mes,
          aderencia_cadencia: 0,
          cadencia_toneladas: 0,
          km_rodados: 0,
          peso_volume: 0,
          quantidade_ctes: 0,
          quantidade_lotes: 0,
          quantidade_viagens: 0,
          tku: 0,
          valor_custo: 0,
          valor_tku: 0,
        };
      }
      agg[currentValue[propName]].aderencia_cadencia +=
        currentValue.aderencia_cadencia;
      agg[currentValue[propName]].cadencia_toneladas +=
        currentValue.cadencia_toneladas;
      agg[currentValue[propName]].km_rodados += currentValue.km_rodados;
      agg[currentValue[propName]].peso_volume += currentValue.peso_volume;
      agg[currentValue[propName]].quantidade_ctes +=
        currentValue.quantidade_ctes;
      agg[currentValue[propName]].quantidade_lotes +=
        currentValue.quantidade_lotes;
      agg[currentValue[propName]].quantidade_viagens +=
        currentValue.quantidade_viagens;
      agg[currentValue[propName]].tku += currentValue.tku;
      agg[currentValue[propName]].valor_custo += currentValue.valor_custo;
      agg[currentValue[propName]].valor_tku += currentValue.valor_tku;
      return agg;
    }, {})
  );
